import { render, staticRenderFns } from "./companyCreditEvaluationDetail.vue?vue&type=template&id=13b66d18&scoped=true"
import script from "./companyCreditEvaluationDetail.vue?vue&type=script&lang=js"
export * from "./companyCreditEvaluationDetail.vue?vue&type=script&lang=js"
import style0 from "./companyCreditEvaluationDetail.vue?vue&type=style&index=0&id=13b66d18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b66d18",
  null
  
)

export default component.exports